<template>
  <div class="container-fluid" style="background-color:white;">
    <div class="row">
      <div class="col">
        <div class="d-flex" style="position:fixed; bottom:10px; right:40px; text-align:right;">
          <b-button-group class="mr-2">
            <b-button class="px-1" style="width:55px; height:38px;" @click="scaleUp()">
              <font-awesome-icon :icon="['fas', 'search-plus']" class="icon"/>
            </b-button>
            <b-button class="px-1" style="width:55px; height:38px;" @click="scaleDown()">
              <font-awesome-icon :icon="['fas', 'search-minus']" class="icon"/>
            </b-button>
          </b-button-group>

          <b-pagination
            class="mb-0"
            :total-rows="pageCount"
            :per-page="1"
            v-model="pageNum"
            v-on:change="changePage"
          ></b-pagination>
        </div>
        <canvas id="pdf-canvas" style="box-shadow:0 0 3px gray;" oncontextmenu="return false;" v-bind:style="canvasStyle"/>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import http from "../plugins/http"

export default Vue.extend({
  props: ["base64Pdf"],
  data(){
    return{
      pdfDoc: null,
      pageCount: 0,
      pageNum: 1,
      pageRendering: false,
      pageNumPending: null,
      scale: 1.0,
      dpiScale: 300 / 72,
      baseWidth: 0,
      baseHeight: 0,
    }
  },
  computed: {
    canvasStyle: function(){
      var rtn = {};
      rtn["width"] = this.baseWidth * this.scale + "px";
      rtn["height"] = this.baseHeight * this.height + "px";
      return rtn;
    },
  },
  methods: {
    // Base64形式でダウンロードしたPDFファイル読み込み
    loadPdf(){
      var self = this;
      pdfjsLib.getDocument({data: atob(this.base64Pdf)}).promise.then(function(pdfDoc_) {
        self.pdfDoc = pdfDoc_;
        self.pageCount = self.pdfDoc.numPages;

        // 1ページ目をレンダリング
        self.renderPage(self.pageNum);
      })
    },
    // PDFレンダリング処理
    renderPage(pageNum){
      // pdfDocの匿名関数内でthisのスコープが変わってしまうためローカル変数に代入
      var self = this;

      self.pageRendering = true;
      // Using promise to fetch the page
      self.pdfDoc.getPage(pageNum).then(function(page) {
        var canvas = document.getElementById("pdf-canvas");
        var ctx = canvas.getContext('2d');

        var viewport = page.getViewport({scale: 1});
        canvas.height = viewport.height * self.dpiScale;
        canvas.width = viewport.width * self.dpiScale;

        self.baseHeight = viewport.height;
        self.baseWidth = viewport.width;

        // Render PDF page into canvas context
        var renderContext = {
          canvasContext: ctx,
          viewport: viewport,
          transform: [self.dpiScale, 0, 0, self.dpiScale, 0, 0],
        };
        var renderTask = page.render(renderContext);

        // Wait for rendering to finish
        renderTask.promise.then(function() {
          self.pageRendering = false;
          if (self.pageNumPending !== null) {
            // New page rendering is pending
            self.renderPage(self.pageNumPending);
            self.pageNumPending = null;
          }
        });
      });

      // Update page counters
      self.pageNum = pageNum;
    },
    // ページ切り替え
    changePage(pageNum){
      this.pageNum = pageNum;
      this.queueRenderPage(this.pageNum);
    },
    // ページ切り替えボタンから呼ばれるレンダリング処理
    queueRenderPage(num){
      if (this.pageRendering) {
        // ページ切り替え処理中の場合、ページ番号を保持しペンディング
        this.pageNumPending = num;
      } else {
        this.renderPage(num);
      }
    },
    scaleUp(){
      this.scale += 0.05;
    },
    scaleDown(){
      this.scale -= 0.05;
    }
  },
  watch: {
    "base64Pdf": function(newVal, oldVal){
      if(newVal.length > 0){
        this.pageNum = 1;
        this.loadPdf();
      }
    }
  }
})
</script>